import React, { useRef } from 'react';
import { Sticky } from './Sticky';
import { useScrollAppear } from './useScrollAppear';
import { useForkRef } from '../../hooks/useForkRef';
export function ScrollSticky(props) {
    const { initialHeight, threshold, offset, disabled, forwardRef, ...restProps } = props;
    const childStickyRef = useRef(null);
    const childForkRef = useForkRef(forwardRef, childStickyRef);
    const offsets = useScrollAppear(childStickyRef, { offset, threshold, initialHeight, disabled });
    return (React.createElement(Sticky, Object.assign({}, restProps, offsets, { forwardRef: childForkRef })));
}
//# sourceMappingURL=ScrollSticky.js.map